import { Card, Row, Col, Statistic } from 'antd';
import type { ReactNode } from 'react';

export interface DataStat {
  title: string;
  value: number;
  prefix?: ReactNode;
  valueStyle?: React.CSSProperties;
}

interface DataStatsProps {
  stats: DataStat[];
  className?: string;
}

const DataStats: React.FC<DataStatsProps> = ({ stats, className }) => {
  return (
    <Row gutter={[16, 0]} className={className}>
      {stats.map((stat, index) => (
        <Col span={6} key={index}>
          <Card>
            <Statistic
              title={stat.title}
              value={stat.value}
              prefix={stat.prefix}
              valueStyle={stat.valueStyle}
            />
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default DataStats;
